import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserServices } from '../../services/userservices';

@Component({
  selector: 'app-bulk-reassign-dialog',
  templateUrl: './bulk-reassign-dialog.component.html',
  styleUrls: ['./bulk-reassign-dialog.component.css']
})
export class BulkReassignDialogComponent implements OnInit {

  // Correct type (object, not array)
  selectedCounsellor: any = {};

  counsellorList: any[] = [];
  selectedUserName: string = ''; // for dropdown binding

  constructor(
    public dialogRef: MatDialogRef<BulkReassignDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private counsellorService: UserServices
  ) {
    console.log('=== Dialog Constructor ===');
    console.log('Data received:', data);

    if (data?.counsellors && Array.isArray(data.counsellors)) {
      this.counsellorList = data.counsellors;
      console.log('Counsellor list assigned:', this.counsellorList);
    }
  }

  ngOnInit(): void {

    // Load counsellors from API
    this.counsellorService.getAllUsers().subscribe(resp => {
      if (resp) {
        this.counsellorList = resp.filter(fl =>
          fl.userType === 'Counsellor' && fl.currentStatus === 'Active'
        );
      }
      console.log('Counsellor list:', this.counsellorList);
    });

  }

  onAssign(): void {


    const select = document.getElementById("counsellorSelect") as HTMLSelectElement;

    if (!select || select.selectedIndex === -1) {
      alert("No counsellor selected");
      return;
    }

    const selectedText = select.options[select.selectedIndex].text;
    const selectedValue = this.counsellorList.find(c => c.userName === selectedText)?.refNo || '0';

    // Assign object values
    this.selectedCounsellor = {
      name: selectedText,
      userRefNo: selectedValue
    };



    this.dialogRef.close({
      action: 'assign',
      selectedCounsellor: this.selectedCounsellor
    });
  }

  onClose(): void {
    this.dialogRef.close({ action: 'close' });
  }
}
